import { twMerge } from "tailwind-merge";

export function cn(...values: Array<string | false | null | undefined>): string {
  return twMerge(values.filter(Boolean).join(" "));
}

export type ClassNameProp<State> = string | ((state: State) => string | undefined) | undefined;

export function resolveClassName<State>(
  className: ClassNameProp<State>,
  defaultClasses: string,
): string | ((state: State) => string | undefined) {
  if (typeof className === "function") {
    return (state: State) => cn(defaultClasses, className(state));
  }
  return cn(defaultClasses, className);
}
